import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {isAnyHit} from 'src/app/_utils/consumer';
import {fromSessionOr} from '../../../_utils/storage';
import {EAML_REQUEST_CACHE_KEY, EAML_RESPONSE_CACHE_KEY, IFS_REQUEST_CACHE_KEY, IFS_RESPONSE_CACHE_KEY} from '../../../_constants/constants';
import {Router} from '@angular/router';
import {EamlRequest, IfsRequest} from '../../../_data/reports/ifs/ifs-request';
import {I18nService} from '../../../_services/gui/i18n.service';
import {TabBarService} from '../../../_services/gui/tab-bar.service';
import {ConsumerReport} from '../../../_data/reports/consumer/consumer-report';
import {tap} from 'rxjs/operators';
import {exists} from '../../../_utils/operators';
import {IfsReportsService} from '../../../_services/data/reports/ifs-reports.service';
import {NotificationService} from '../../../_services/gui/notification.service';
import {EamlReport, IfsReport} from '../../../_data/reports/ifs/ifs-report';
import {CONSUMER_PDF_CSS} from '../../../_constants/pdf-report/consumer-css';
import {ConsumerRequestReport} from '../ifs-report/ifs-report.component';
import {PdfReactorHeaderComponent} from '../../../common/pdf-reactor-header/pdf-reactor-header.component';
import {SidenavComponent} from '../../../sidenav/sidenav.component';
import {CardComponent} from '../../../sidenav/card/card.component';
import {ConsumerCreditReportSidenavComponent} from '../consumer-credit-report/consumer-sidenav/consumer-credit-report-sidenav.component';
import {PdfButtonBarComponent} from '../../../common/pdf-button-bar/pdf-button-bar.component';
import {IfsReportContentComponent} from '../ifs-report/ifs-report-content/ifs-report-content.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-eaml-report',
    templateUrl: './eaml-report.component.html',
    styleUrls: ['./eaml-report.component.scss'],
    imports: [SidenavComponent, PdfReactorHeaderComponent, CardComponent, ConsumerCreditReportSidenavComponent, PdfButtonBarComponent, IfsReportContentComponent, TranslateModule]
})
export class EamlReportComponent implements OnInit, OnDestroy {

  isAnyHit = isAnyHit;

  _appCard: ElementRef;
  _creditReportRef: ElementRef;
  _ifsReportRef: ElementRef;
  consumerReportCss: string = CONSUMER_PDF_CSS;
  thisOrder: {lang; ref; branch; resultsIssued?};
  consumerRequestReport: ConsumerRequestReport;

  i18nService = inject(I18nService);
  private readonly eamlRequest: EamlRequest;
  private eamlReport: EamlReport;
  private router = inject(Router);
  private tabBarService = inject(TabBarService);
  private cdRef = inject(ChangeDetectorRef);
  private notificationService = inject(NotificationService);
  private ifsReportsService = inject(IfsReportsService);

  constructor() {
    const router = this.router;

    this.eamlRequest = JSON.parse(sessionStorage.getItem(EAML_REQUEST_CACHE_KEY));

    if(!this.eamlRequest) {
      console.warn('Consumer request data missing');
      router.navigateByUrl('/consumer-services');
    }
  }

  ngOnInit(): void {
    this.i18nService.setTitle('title.consumer-report');
    this.tabBarService.show();

    fromSessionOr(EAML_RESPONSE_CACHE_KEY, this.ifsReportsService.getEamlReport(this.eamlRequest)).pipe(
      tap(report => {
        if(!report) {
          this.notificationService.displayI18n('content.report.messages.report-failed');
          console.error('Report null.');
        }
      }),
      exists()
    ).subscribe(report => {
      console.info('Report received');
      this.eamlReport = report.body;
      this.consumerRequestReport = {req: this.eamlRequest?.consumer, report: this.eamlReport.consumerReport};

      console.debug(`Consumer Request: ${JSON.stringify(this.consumerRequestReport)}`);
      console.debug(`Consumer Report: ${JSON.stringify(this.consumerReport)}`);
      console.debug(`IFS Request: ${JSON.stringify(this.ifsRequest)}`);
      console.debug(`IFS Report: ${JSON.stringify(this.ifsReport)}`);
    });

  }

  ngOnDestroy() {
    //If the user intentionally navigates away from the report, clear the storage for the request/response.
    sessionStorage.removeItem(EAML_REQUEST_CACHE_KEY);
    sessionStorage.removeItem(EAML_RESPONSE_CACHE_KEY);
    sessionStorage.removeItem(IFS_REQUEST_CACHE_KEY);
    sessionStorage.removeItem(IFS_RESPONSE_CACHE_KEY);
  }

  set creditReportRef(value: ElementRef) {
    this._creditReportRef = value;
    this.cdRef.detectChanges();
  }

  set ifsReportRef(value: ElementRef) {
    this._ifsReportRef = value;
    this.cdRef.detectChanges();
  }

  // get consumerRequestReport(): ConsumerRequestReport {
  //   return ;
  // }

  get consumerReport(): ConsumerReport {
    return this.eamlReport?.consumerReport;
  }

  get ifsRequest(): IfsRequest {
    return this.eamlRequest?.ifsInquiry;
  }

  get ifsReport(): IfsReport {
    return this.eamlReport?.ifsReport;
  }

  @ViewChild(PdfReactorHeaderComponent, {read: ElementRef})
  set appCard(appCard: ElementRef) {
    this._appCard = appCard;
    this.cdRef.detectChanges();
  }

}
